module.exports = __webpack_public_path__ + "static/media/ic_bag.9ff92c63.svg";